import React from "react";
import { useAppSelector } from "store/hooks";
import { selectIsManager } from "store/reducers";
import { useUpdateOvertimeMutation } from "store/reducers/overtime";

import { Button } from "./button";
import { Modal } from "./modal";

export function OvertimeModal(props: { overtime: Overtime; dismissModal: () => void }) {
  const { overtime, dismissModal } = props;

  return (
    <Modal title={<span>Overtime reason</span>} dismissModal={dismissModal}>
      <div className="whitespace-pre-wrap text-sm text-primary">{overtime.reason}</div>
    </Modal>
  );
}

export type OvertimeParent = "TIMESHEET" | "SUMMARY" | "MODAL";

interface OvertimeButtonProps {
  date: string;
  timesheetEmployeeId: number;
  currentEmployeeId?: number;
  overtime: Overtime | undefined;
  parent: OvertimeParent;
  overtimeDuration: number | null;
}

export function OvertimeButtons({
  date,
  timesheetEmployeeId,
  overtime,
  parent,
  overtimeDuration,
}: OvertimeButtonProps) {
  const isManager = useAppSelector(selectIsManager);

  const [updateOvertime] = useUpdateOvertimeMutation();

  function approveOvertime(overtimeId: number) {
    updateOvertime({
      id: overtimeId,
      status: "approved",
      employee_id: timesheetEmployeeId,
      when: date,
    });
  }

  function declineOvertime(overtimeId: number) {
    updateOvertime({
      id: overtimeId,
      status: "declined",
      employee_id: timesheetEmployeeId,
      when: date,
    });
  }

  function setPendingOvertime(overtimeId: number) {
    updateOvertime({
      id: overtimeId,
      status: "pending",
      employee_id: timesheetEmployeeId,
      when: date,
    });
  }

  if (parent === "TIMESHEET" && overtimeDuration === null && !overtime) {
    // We check !overtime, to ensure that if an overtime request exists - we show it, even if the shifts were edited
    return null;
  }

  if (!isManager || !overtime) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="flex justify-center gap-1">
        {/* Manager view */}
        {overtime.status === "pending" && (
          <Button
            onClick={() => approveOvertime(overtime.id)}
            colour="success"
            size="sm"
            title="Approve this overtime request"
          >
            Approve
          </Button>
        )}
        {overtime.status === "pending" && (
          <Button
            onClick={() => declineOvertime(overtime.id)}
            colour="danger"
            size="sm"
            title="Decline this overtime request"
          >
            Decline
          </Button>
        )}
        {(parent === "MODAL" || parent === "SUMMARY") && overtime.status !== "pending" && (
          <Button
            onClick={() => setPendingOvertime(overtime.id)}
            colour="primary"
            size="sm"
            title="Set this overtime request back to pending"
          >
            Set Back to Pending
          </Button>
        )}
      </div>
    </div>
  );
}
